import { useContext } from "react";
import {
  Avatar,
  Typography,
  Stack,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import FirebaseContext from "../context/FirebaseContext";
import { signOut, getAuth } from "firebase/auth";
import signIn from "../helpers/signIn";
export default function DialogSignIn(props) {
  const { open, handleClose, message } = props;
  const firebaseApp = useContext(FirebaseContext);
  const auth = getAuth(firebaseApp);
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        <Stack alignItems="center">
          <Button
            sx={{ mt: 2, textTransform: "none" }}
            variant="contained"
            color="common"
            size="medium"
            onClick={e => {
              e.preventDefault();
              signIn(auth);
              handleClose();
            }}
          >
            <Avatar sx={{ width: 20, height: 20, mr: 1 }} src="/images/google_logo.svg" />
            <Typography>Sign in with Google</Typography>
          </Button>
          <FormControlLabel
            sx={{ mt: 1 }}
            control={<Checkbox size="small" />}
            label={
              <Typography variant="body2" sx={{ fontSize: 13 }}>
                Receive product & promotional updates via email
              </Typography>
            }
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
